function fn_comp_cart() {
    var $fn = $(".part_cart_form");

    if($fn.length) {
        $fn.on("click",".elm_legend",function (e) {
            e.preventDefault();
            var $this = $(this);

            $this.next("fieldset").stop().slideToggle(500,function () {
                $this.toggleClass("mod--active");
                $this.next("fieldset").toggleClass("mod--active");
            })
        })
    }
}